import { registerReducer } from 'foremanReact/common/MountingService';
import rootReducer from '../redux/reducers';

export default () =>
  registerReducer('foremanRemoteExecutionReducers', rootReducer);



// WEBPACK FOOTER //
// ./vendor/ruby/2.7.0/gems/foreman_remote_execution-10.1.1/webpack/react_app/extend/reducers.js